import React from 'react';
import { Fragment, useState } from 'react';
import { Container, Button, Row, Col, Form, FloatingLabel, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header'
import Footer from '../../components/footer';
import LgpdService from '../../services/lgpd';
import Head from '../../components/head';
import '../../styles/lgpd.scss'


function LGPDFormScreen() {
    const [email, setEmail] = useState("");
    const [opt, setOpt] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState();

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            setSucesso(true)
            const lgpd = await LgpdService.cadastro({
                email: email,
                opt: opt
            })
            setError(false)
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Head titulo="Solicitação de dados pessoais - Lei Geral de Proteção de Dados - Portal da Transparência da Prefeitura de Macuco" />
                <Header />
                <Container>
                    <Fragment>
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={1}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="O que deseja?">
                                        <FloatingLabel
                                            label="O que deseja?"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="O que deseja?"
                                                name="tipo"
                                                onChange={e => setOpt(e.target.value)}
                                            >
                                                <option>SELECIONE UMA OPÇÃO</option>
                                                <option value="Consulta dados pessoais existentes">Consultar dados pessoais existentes</option>
                                                <option value="Solicitação de exclusão de dados pessoais">Solicitar exclusão de dados pessoais</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="E-mail">
                                        <FloatingLabel
                                            label="E-mail"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="email"
                                                value={email}
                                                onChange={e => setEmail(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Button variant="primary" type="submit">
                                Enviar solicitação
                            </Button>
                        </Form >
                        <br />
                        <Link to={'/lgpd'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment >
                </Container>
                <Footer />
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Head titulo="Solicitação de dados pessoais - Lei Geral de Proteção de Dados - Portal da Transparência da Prefeitura de Macuco" />
                <Header />
                <Container>
                    <Fragment>
                        <Alert variant='success'>Sua requisiçao foi submetida com sucesso, em breve retornaremos o contato via e-mail cadastrado!</Alert>
                        <br /><br />
                        <br /><br />
                        <Link to={'/lgpd'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment>
                </Container>
                <Footer />
            </Fragment>
        )
    }
}

export default LGPDFormScreen;